import React from 'react';
import { default as Form } from 'components/connectedForm';
import ExpandedRowRenderer from 'components/EditableDataGrid/ExpandedRowRenderer';
import styled from 'styled-components';
import BlurTextField from 'components/connectedForm/BlurTextField/BlurTextField';

const LineBreak = styled.div`
  padding-top: 10px;
  border-top: 2px solid darkgray;
`;

const ExpansionContainer = styled.div`
  padding-left: 10px;
  padding-top: 8px;
  width: 90%;
`;

const PotentialPrice = (props) => {
  const { precision, uuid, priceOriginDescription, nettPrice, description, priceBreak, pricePriority } = props;
  const title = description;
  const quantityBreakField = priceBreak ? <BlurTextField value={priceBreak} label={'for'} readOnly={true} /> : null;

  return (
    <Form.Row key={uuid}>
      <Form.Fieldset cols={1 / 4}>
        <BlurTextField
          value={nettPrice}
          label={title}
          decimals={precision}
          readOnly={true}
          labelCols={1 / 2}
          inputCols={1 / 2}
        />
      </Form.Fieldset>
      <Form.Fieldset cols={1 / 4}>{quantityBreakField}</Form.Fieldset>
      <Form.Fieldset cols={1 / 4}>
        <BlurTextField value={priceOriginDescription} includeLabel={false} readOnly={true} />
      </Form.Fieldset>
      {pricePriority && pricePriority !== 'NONE' ? (
        <Form.Fieldset cols={1 / 4}>
          <BlurTextField value={pricePriority} includeLabel={false} readOnly={true} />
        </Form.Fieldset>
      ) : null}
    </Form.Row>
  );
};

const Prices = (props) => {
  const potentialPrices = props.row?.pricePotentialList;

  if (!potentialPrices || potentialPrices?.length === 0) {
    return null;
  }

  const pricing = potentialPrices.map((price, index) => <PotentialPrice key={`_${index}`} {...price} />);

  return (
    <LineBreak>
      <ExpansionContainer>{pricing}</ExpansionContainer>
    </LineBreak>
  );
};

export const PriceExpansion = (props) => {
  return <ExpandedRowRenderer {...props} expansion={Prices} />;
};
